import { render, staticRenderFns } from "./CashGive.vue?vue&type=template&id=46f666f9&scoped=true&"
import script from "./CashGive.vue?vue&type=script&lang=js&"
export * from "./CashGive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f666f9",
  null
  
)

export default component.exports